(function(){
  const header = document.querySelector('.site-header');
  if (!header) return;
  // progress bar element
  const progressEl = document.createElement('div');
  progressEl.className = 'site-header__progress';
  header.querySelector('.site-header__bar').appendChild(progressEl);
  header.classList.add('show-progress');

  // hide/reveal on scroll
  let lastY = window.scrollY, hidden = false;
  const onScroll = ()=>{
    const y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 8);
    const down = y > lastY && y > 120;
    if (down !== hidden){
      hidden = down;
      header.classList.toggle('is-hidden', hidden);
    }
    lastY = y;

    // progress
    const body = document.documentElement;
    const h = body.scrollHeight - body.clientHeight;
    const p = h > 0 ? (y / h) * 100 : 0;
    header.style.setProperty('--progress', p.toFixed(2) + '%');
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive:true });

  // scroll-spy for nav
  const links = [...document.querySelectorAll('[data-spy]')];
  const byId = id => links.filter(a => a.dataset.spy === id);
  const sections = ['about','services','gallery','contact']
    .map(id => document.getElementById(id))
    .filter(Boolean);

  const spy = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if (e.isIntersecting){
        const id = e.target.id;
        links.forEach(a => a.classList.toggle('is-active', a.dataset.spy === id));
      }
    });
  }, { rootMargin: '-35% 0px -55% 0px', threshold: 0 });

  sections.forEach(s => spy.observe(s));

  // mobile drawer
  const toggle = header.querySelector('.nav-toggle');
  const drawer = document.getElementById('nav-drawer');
  const openDrawer = (open)=>{
    header.classList.toggle('mobile-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    drawer.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) drawer.querySelector('a')?.focus();
  };
  toggle?.addEventListener('click', ()=> openDrawer(!header.classList.contains('mobile-open')));
  drawer?.addEventListener('click', (e)=>{ if (e.target.matches('a')) openDrawer(false); });

  // offset anchor scroll (sticky header)
  const navLinks = header.querySelectorAll('a[href^="#"]');
  navLinks.forEach(a=>{
    a.addEventListener('click', (e)=>{
      const id = a.getAttribute('href').slice(1);
      const el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      const rect = el.getBoundingClientRect();
      const offset = rect.top + window.scrollY - header.offsetHeight - 8;
      window.scrollTo({ top: offset, behavior: 'smooth' });
      openDrawer(false);
    });
  });
})();
